
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/amazon",
      function () {
        return require("private-next-pages/amazon.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/amazon"])
      });
    }
  